import { getServerDate } from "../../config/dateformatter";

// Builds the JSON body for POST / PUT Management/halal-stock-ipos. The key set
// mirrors the Postman "List an offer in IPO" / "Edit an IPO" requests exactly;
// PUT sends the same full body as POST (stock identity fields are echoed
// back unchanged — the API ignores them on edit).
export const buildIpoPayload = (values) => {
  const payload = {};

  const set = (key, value) => {
    if (value !== undefined && value !== null && value !== "") {
      payload[key] = value;
    }
  };

  const setNumber = (key, value) => {
    if (value !== undefined && value !== null && value !== "") {
      payload[key] = Number(value);
    }
  };

  // Stock: either an existing inactive stock by id, or created inline.
  if (values.stock_source?.value === "existing") {
    setNumber("shariah_stock_id", values.shariah_stock_id?.value);
  } else {
    set("symbol", values.symbol);
    set("name", values.name);
    set("currency", values.currency?.value);
  }

  setNumber("offer_price", values.offer_price);
  if (values.offer_open_date) {
    payload.offer_open_date = getServerDate(values.offer_open_date);
  }
  if (values.offer_close_date) {
    payload.offer_close_date = getServerDate(values.offer_close_date);
  }
  setNumber("min_subscription_shares", values.min_subscription_shares);
  setNumber("admin_fee_pct", values.admin_fee_pct);
  setNumber("total_shares_on_offer", values.total_shares_on_offer);

  set("exchange", values.exchange);
  set("sector", values.sector);
  set("logo_url", values.logo_url);
  set("issuer", values.issuer);
  set("overview", values.overview);
  set("highlights", values.highlights);
  set("key_information", values.key_information);
  set("risk_disclosure", values.risk_disclosure);
  set("prospectus_url", values.prospectus_url);
  set("status", values.status?.value);

  return payload;
};
